import React from 'react';

import { Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { ComplianceTable } from './ComplianceTable';
import { getComplianceHistory, fetchComplianceHistory } from '../redux';
import { ComplianceSummary } from './ComplianceSummary';
import { createOverviewSummaryData } from '../utils';
import { UiReportDownload } from '../../ui/ui-kit/UiReportDownload';
import { InnerLoader, useEffectAfterMount } from '../../ui';

const ComplianceHistory = ({
  user,
  userFilters,
  shouldFetchHistory,
  fetchComplianceHistory,
  complianceHistory,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [filteredData, setFilteredData] = React.useState([]);

  const refreshHistoryData = () => {
    if (shouldFetchHistory) {
      if (user.financialInstitutionId) {
        setLoading(true);
        fetchComplianceHistory({
          financialInstitutionId: user.financialInstitutionId,
          accountId: user.accountId,
          merchantIds: userFilters.accounts,
          start: userFilters.startDate,
          end: userFilters.endDate,
        }).then(() => setLoading(false));
      }
    }
  };

  useEffectAfterMount(() => {
    refreshHistoryData();
  }, [userFilters, shouldFetchHistory]);

  React.useEffect(() => {
    if (!complianceHistory.historyData) {
      refreshHistoryData();
    }
  }, []);

  if (!shouldFetchHistory) {
    return null;
  }
  if (loading) {
    return <InnerLoader visible />;
  }
  return complianceHistory.historyData ? (
    <>
      <ComplianceSummary
        data={complianceHistory.historyData}
        tableData={createOverviewSummaryData(complianceHistory.historyData)}
      />
      <br />
      <Columns>
        <Column>
          <MuiTitle isSize="4" hasTextColor="info" tag="h2">
            Success Results &amp; Resolved Flaggings
          </MuiTitle>
        </Column>
        <Column style={{ textAlign: 'right' }}>
          <UiReportDownload
            data={filteredData}
            filename="Compliance_Overview"
          />
        </Column>
      </Columns>
      <ComplianceTable
        loading={loading}
        data={complianceHistory.historyData?.items || []}
        dataCallback={setFilteredData}
        user={user}
      />
    </>
  ) : null;
};

const mapStateToProps = state => ({
  complianceHistory: getComplianceHistory(state),
});

const connectedComplianceHistory = connect(mapStateToProps, {
  fetchComplianceHistory,
})(ComplianceHistory);

connectedComplianceHistory.propTypes = {
  userFilters: propTypes.object.isRequired,
  shouldFetchHistory: propTypes.bool.isRequired,
};

ComplianceHistory.propTypes = {
  ...connectedComplianceHistory.propTypes,
  user: propTypes.object.isRequired,
};

export { connectedComplianceHistory as ComplianceHistory };
